module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Rain#5-aa2e89611c921dbf48c6890c9b52cf16.svg";